import { gql } from "@stadium/services/apollo-client";
import { BASIC_VARIANT_PRICE_DETAILS_SERVER } from "@graphql/fragments/product/server/basic-variants-price-details";

export const BASIC_VARIANT_PRICE_DETAILS = gql`
  ${BASIC_VARIANT_PRICE_DETAILS_SERVER}
`;
